import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import routes from "../../../constants/routes";
const Sidebar = () => {
    const location = useLocation();
    const { t } = useTranslation();
    const [openMenuMb, setOpenMenuMb] = useState(false);
    const [currentPath, setCurrentPath] = useState(null);

    useEffect(() => {
        setOpenMenuMb(false);
        setCurrentPath(
            location.pathname?.split("/")[1]
                ? location.pathname?.split("/")[1]
                : null
        );
    }, [location]);

    return (
        <div className={`components-sidebar ${openMenuMb ? "active" : ""}`}>
            <div className="logo-container">
                <Link to={routes.dashboard} className="logo">
                    <img src="/images/logo.svg" alt="" />
                </Link>
                <div
                    className="close-mb"
                    onClick={() => setOpenMenuMb((prev) => !prev)}
                >
                    <img
                        src={
                            openMenuMb
                                ? `/images/close2.svg`
                                : "/images/hamburger.svg"
                        }
                        alt=""
                    />
                </div>
            </div>

            <ul className="links">
                <li className={currentPath === null ? "active" : ""}>
                    <Link to={routes.dashboard}>
                        <img src="/images/sidebar1.svg" alt="" />
                        {t("sidebar.Dashboard")}
                    </Link>
                </li>
                <li
                    className={
                        routes.wallet?.includes(currentPath) ? "active" : ""
                    }
                >
                    <Link to={routes.wallet}>
                        <img src="/images/sidebar2.svg" alt="" />{" "}
                        {t("sidebar.Wallet")}
                    </Link>
                </li>
                <li
                    className={
                        routes.history?.includes(currentPath) ? "active" : ""
                    }
                >
                    <Link to={routes.history}>
                        <img src="/images/sidebar3.svg" alt="" />
                        {t("sidebar.History")}
                    </Link>
                </li>
                <li
                    className={
                        routes.createToken?.includes(currentPath)
                            ? "active"
                            : ""
                    }
                >
                    <Link to={routes.createToken}>
                        <img src="/images/sidebar5.svg" alt="" />{" "}
                        {t("sidebar.Tokens")}
                    </Link>
                </li>
                <li
                    className={
                        routes.developer?.includes(currentPath) ? "active" : ""
                    }
                >
                    <a
                        href="https://developers.rivius.network/"
                        target="_blank"
                    >
                        <img src="/images/sidebar4.svg" alt="" />{" "}
                        {t("sidebar.Developers")}
                    </a>
                </li>
            </ul>
            <div className="bottom">
                <div className="socials">
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://t.me/Therivius"
                    >
                        <img src="/images/telegram.svg" alt="" />
                    </a>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://twitter.com/Therivius"
                    >
                        <img src="/images/twitter.svg" alt="" />
                    </a>
                    <a target="_blank" rel="noreferrer" href="/#">
                        <img src="/images/discord.svg" alt="" />
                    </a>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.facebook.com/Therivius"
                    >
                        <img src="/images/facebook.svg" alt="" />
                    </a>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.instagram.com/riviusnetwork/"
                    >
                        <img src="/images/instagram.svg" alt="" />
                    </a>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.tiktok.com/@riviusnetwork"
                    >
                        <img src="/images/tiktok.svg" alt="" />
                    </a>
                </div>
                <div className="copyright">
                    <a
                        href="https://vietnamblockchain.vn"
                        target="_blank"
                        className="logo"
                    >
                        <img src="/images/logo-vbi.svg" alt="" />
                    </a>
                    <div className="text">
                        {t("sidebar.© 2022 VBI. All rights reserved.")}{" "}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
